import React, { useContext, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, TextField, IconButton } from '@material-ui/core';
import api from 'api/Assessor/duvidas';
import ErrorHandler from 'utils/ErrorHandler';
import TextRange from 'utils/TextRange';
import { SendIcon, SyncIcon, CloseIcon } from 'components/Icons';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import ChatContext from './ChatContext';
import useStyle from './style';
import { getToastSuccess } from 'utils/ToasterUtils';

export default function () {
  const { t } = useTranslation();
  const classes = useStyle();
  const { auth, atualizarMensagens } = useContext(MensagensContext);
  const { duvidaAtual, updateDuvida, setDuvida } = useContext(ChatContext);
  const [enviando, setEnviando] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const resposta = TextRange(e.currentTarget.value);
    updateDuvida({ resposta });
  };

  const handleSubmit = useCallback(
    async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      setEnviando(true);
      const { fail, response } = await api.responder({
        idPergunta: duvidaAtual!.idPergunta,
        resposta: duvidaAtual!.resposta!,
      });
      setEnviando(false);
      if (fail) {
        ErrorHandler(fail);
      }
      if (response && response.status === 200) {
        getToastSuccess(t('AssessorMensagens.success-answer'));
        setDuvida(undefined);
        atualizarMensagens();
      }
    },
    [duvidaAtual, atualizarMensagens, t, setDuvida]
  );

  if (!auth?.responder || !duvidaAtual) return null;

  return (
    <form
      className={[classes.input, 'animation-slide-up'].join(' ').trim()}
      onSubmit={handleSubmit}
    >
      <div className={classes.inputDuvida}>
        <Typography className={classes.inputDuvidaText}>
          {duvidaAtual.pergunta}
        </Typography>
        <IconButton
          className={classes.cancelarResposta}
          onClick={() => setDuvida(undefined)}
        >
          <CloseIcon />
        </IconButton>
      </div>
      <TextField
        className={classes.textField}
        placeholder={t('AssessorMensagens.write')}
        onChange={handleChange}
        InputProps={{
          endAdornment: (
            <div className={classes.endAdornment}>
              <Typography className={classes.counter}>
                {(duvidaAtual?.resposta || '').length}/500
              </Typography>
              <IconButton
                type="submit"
                className={classes.submitIcon}
                color="primary"
                disabled={
                  enviando || !((duvidaAtual?.resposta || '').length > 0)
                }
              >
                {enviando ? <SyncIcon animated /> : <SendIcon />}
              </IconButton>
            </div>
          ),
          disableUnderline: true,
        }}
        value={duvidaAtual?.resposta || ''}
        rowsMax={10}
        multiline
        fullWidth
        autoFocus
        disabled={enviando}
      />
    </form>
  );
}
